import { produce } from "immer";
import * as Actions from "pages/Archive/store/archiveActions";
import * as archivesActions from "pages/Archive/store/archivesActions";

const initialState = {
  currentId: null,
  isLoading: false,
  errorMessage: null,
  isDetailsOpen: false,
  isDeleteOpen: false,
  isDownloadOpen: false,
  downloadType: null,
  searchParams: null,
  totalCount: 0,
  currentPage: 1,
  isSavedSearchesOpen: false,
  isSavedSearchAddOpen: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPEN_DETAILS:
      draft.isDetailsOpen = true;
      draft.currentId = action.payload.id;
      break;

    case Actions.CLOSE_DETAILS:
      draft.isDetailsOpen = false;
      draft.currentId = null;
      break;

    case Actions.OPEN_DELETE:
      draft.isDeleteOpen = true;
      draft.currentId = action.payload.id;
      break;

    case Actions.CLOSE_DELETE:
      draft.isDeleteOpen = false;
      draft.currentId = null;
      break;

    case Actions.DELETE_ARCHIVES:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.DELETE_ARCHIVES_SUCCESS:
      draft.isLoading = false;
      draft.isDeleteOpen = false;
      break;

    case Actions.DELETE_ARCHIVES_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.OPEN_DOWNLOAD:
      draft.isDownloadOpen = true;
      draft.downloadType = action.payload.downloadType;
      break;

    case Actions.CLOSE_DOWNLOAD:
      draft.isDownloadOpen = false;
      draft.downloadType = null;
      draft.errorMessage = null;
      break;

    case Actions.DOWNLOAD_ARCHIVES:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.DOWNLOAD_ARCHIVES_SUCCESS:
      draft.isLoading = false;
      draft.isDownloadOpen = false;
      break;

    case Actions.DOWNLOAD_ARCHIVES_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.SET_SEARCH_PARAMS:
      draft.searchParams = action.payload.searchParams;
      break;

    case archivesActions.FETCH_ARCHIVES_SUCCESS:
    case archivesActions.FETCH_ARCHIVES_APPEND_SUCCESS: {
      const payload = action.payload;
      draft.totalCount = payload.totalCount;
      break;
    }

    case Actions.SET_PAGE: {
      draft.currentPage = action.payload.page;
      break;
    }

    case Actions.RESET_FAILED:
      draft.errorMessage = null;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
